import * as React from 'react'
import { styled } from 'next-yak'

import { RoleTag } from './tag/RoleTag'

import * as S from '../styles'
import { RoleTagColors } from '../styles/tag'

type ContentProps = {
  avatar?: string
  avatarSize?: 'extra-small' | 'small' | 'medium' | 'large'
  name?: React.ReactNode
  tag?: Tag
}

export type UserLabelProps = {
  isPublic: boolean
  className?: string
  href?: string
} & React.ComponentPropsWithoutRef<'div'> &
  ContentProps &
  React.AnchorHTMLAttributes<HTMLAnchorElement>

type Tag = {
  backgroundColor?: RoleTagColors
  label: string
}

function UserLabelComponent({
  avatar,
  avatarSize,
  className,
  href,
  isPublic,
  name,
  tag,
  ...rest
}: UserLabelProps): React.ReactElement<UserLabelProps> {
  return (
    <>
      {isPublic ? (
        <S.userLabel.UserLabelLink href={href} className={className} {...rest}>
          <Content avatar={avatar} avatarSize={avatarSize} name={name} tag={tag} />
        </S.userLabel.UserLabelLink>
      ) : (
        <S.userLabel.UserLabel className={className}>
          <Content avatar={avatar} avatarSize={avatarSize} name={name} tag={tag} />
        </S.userLabel.UserLabel>
      )}
    </>
  )
}

function Content({ avatar, avatarSize, name, tag }: ContentProps) {
  return (
    <>
      {avatar && <S.image.Avatar src={avatar} type={avatarSize} />}
      {name && (
        <>
          {name} {tag && <RoleTag backgroundColor={tag.backgroundColor}>{tag.label}</RoleTag>}
        </>
      )}
    </>
  )
}

export const UserLabel = styled(UserLabelComponent)<UserLabelProps>``
UserLabel.displayName = 'UserLabel'
